import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

const SIDEBAR_WIDTH = 340;

type RightSidebarLayoutContextValue = {
  isSidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  sidebarWidth: number;
  searchItemsSectionExpandSignal: number;
  expandSearchItemsSection: () => void;
};

const RightSidebarLayoutContext = createContext<RightSidebarLayoutContextValue>({
  isSidebarOpen: true,
  setSidebarOpen: () => {},
  sidebarWidth: SIDEBAR_WIDTH,
  searchItemsSectionExpandSignal: 0,
  expandSearchItemsSection: () => {},
});

export function RightSidebarLayoutProvider({ children }: { children: ReactNode }) {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [searchItemsSectionExpandSignal, setSearchItemsSectionExpandSignal] = useState(0);
  const expandSearchItemsSection = useCallback(() => {
    setSearchItemsSectionExpandSignal(n => n + 1);
  }, []);
  const value: RightSidebarLayoutContextValue = {
    isSidebarOpen,
    setSidebarOpen: useCallback((open: boolean) => setSidebarOpen(open), []),
    sidebarWidth: SIDEBAR_WIDTH,
    searchItemsSectionExpandSignal,
    expandSearchItemsSection,
  };
  return <RightSidebarLayoutContext.Provider value={value}>{children}</RightSidebarLayoutContext.Provider>;
}

export function useRightSidebarLayout() {
  return useContext(RightSidebarLayoutContext);
}

export { SIDEBAR_WIDTH };
